import {
	apiRequest
} from '../api.js'

// 申报管理

//获取已申报列表
export function getApplyList(config){
	config.method = 'get'
	config.url = '/proapi/v1/application/get-application-list'
	apiRequest(config)
}

// 评分
export function givePoint(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/give-point'
	apiRequest(config)
}

// 同意推荐
export function setRecommend(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/recommend'
	apiRequest(config)
}

// 获取申报详情 
export function getApplicationDetail(config){
	config.method = 'get'
	config.url = '/proapi/v1/application/get-application-detail'
	apiRequest(config)
}

// 获取资料上传的项目
export function getDataItem(config){
	config.method = 'get'
	config.url = '/proapi/v1/application/get-data-item'
	apiRequest(config)
}